import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import './../../assets/css/styles.css';
import InputLabel from '@mui/material/InputLabel';
import WarningIcon from '@mui/icons-material/Warning';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import {
  SubHeading,
  Counter,
  // CounterLabel,
  CounterWrap,
  TermsLabel,
  Small,
  SuccessMessage,
  RecaptchaMessage,
} from './styles';
import { CustomTooltip } from '../shared/CustomTooltip';
import { postThirdPartyRequest } from '../shared/api';
import { Footer } from '../shared/Footer';
import { Spinner } from '../shared/Spinner';
import Alert from '@mui/material/Alert';

import {
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  Grid,
} from '@mui/material';
import { redirect } from 'react-router-dom';

const FormContainer = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  height: '100%',
  width: '100%',
  padding: '24px',
  lineHeight: '0.5',
  fontFamily: 'MuseoSans',
  fontSize: '1.728rem',
  color: '#003863',
  fontWeight: '400',
}));

export const RequestForm = () => {
  const [submitClick, setSubmitClick] = useState(false);

  const [nameErrorText, setNameErrortext] = useState('');
  const [nameError, setNameError] = useState(false);

  const [cmpNameErrorText, setCmpNameErrortext] = useState('');
  const [cmpNameError, setCmpNameError] = useState(false);

  const [emailErrorText, setEmailErrortext] = useState('');
  const [emailError, setEmailError] = useState(false);

  const [appNameErrorText, setAppNameErrortext] = useState('');
  const [appNameError, setAppNameError] = useState(false);

  const [redirectUriErrorText, setRedirectUriErrorText] = useState('');
  const [redirectUriError, setRedirectUriError] = useState(false);

  const [granttypeErrorText, setGrantTypeErrorText] = useState('');
  const [granttypeError, setGrantTypeError] = useState(false);

  const [counterURI, setCounterURI] = useState(1);

  const [showSuccessError, setShowSuccessError] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const [errorMessage, setErrorMessage] = useState('');

  const [selectCheckBoxError, setSelectCheckBoxError] = useState(false);

  const [showRecaptchaMessage, setShowRecaptchaMessage] = useState(false);

  const [loading, setLoading] = useState(false);

  const backtoRequestForm = () => {
    setShowSuccessError(false);
    setSuccessMessage('');
    setErrorMessage('');
    setSubmitClick(false);
    setFormData({
      ...formData,
      fullName: '',
      company: '',
      email: '',
      appName: '',
      grantType: '',
      urls: '',
      agree: false,
    });
    redirect('/RequestForm');
  };

  const [formData, setFormData] = useState({
    fullName: '',
    company: '',
    email: '',
    appName: '',
    grantType: '',
    urls: '',
    agree: false,
  });

  // const FormTextField = styled(TextField)({
  //   // '& label.Mui-focused': {
  //   //   fontFamily: 'MuseoSans',
  //   // },
  //   "& .MuiOutlinedInput-root": {
  //     "& fieldset": {
  //       border: "0.20px solid #dee2e6",
  //     },
  //     "&:hover fieldset": {
  //       borderColor: "#dee2e6",
  //     },
  //     "&.Mui-focused fieldset": {
  //       borderColor: "#a9ca9a",
  //     },
  //   },
  // });

  const handleCheckboxchange = (event) => {
    setFormData({ ...formData, agree: event.target.checked });
    setSelectCheckBoxError(false);
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: 'rgb(68,123,44)',
      },
    },
    typography: {
      button: {
        textTransform: 'none',
      },
    },
    input: {
      '&:invalid': {
        border: 'red solid 2px',
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 992,
        lg: 1200,
        xl: 1536,
      },
    },
  });

  theme.typography.h3 = {
    fontSize: '1.2rem',
    '@media (min-width:600px)': {
      fontSize: '0.875rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.5rem',
    },
  };

  /********** Name Error Validations ************/
  const validateFullName = (e) => {
    if (e.target.value.length < 1) {
      setFormData({ ...formData, fullName: '' });
    } else if (e.target.validity.valid) {
      setNameError(false);
      setNameErrortext('');
      setFormData({ ...formData, fullName: e.target.value });
    } else {
      setNameErrortext(displayNameError(e.target.value));
      setNameError(true);
    }
  };

  const displayNameError = (text) => {
    if (text.length < 1) {
      return 'Please enter a full name';
    } else {
      return 'Please enter a valid full name, without special characters such as ^~`!@#$%^&*()_+={}[]|/:;"<>,.?';
    }
  };

  const onBlurNameField = (e) => {
    setSubmitClick(false);
    setNameErrortext('');
    if (e.target.value.length < 1) {
      setNameError(false);
    }
  };

  const onBlurCmpNameField = (e) => {
    setSubmitClick(false);
    setCmpNameErrortext('');
    if (e.target.value.length < 1) {
      setCmpNameError(false);
    }
  };

  const onBlurEmailField = (e) => {
    setSubmitClick(false);
    setEmailErrortext('');
    if (e.target.value.length < 1) {
      setEmailError(false);
    }
  };

  const onBlurAppNameField = (e) => {
    setSubmitClick(false);
    setAppNameErrortext('');
    if (e.target.value.length < 1) {
      setAppNameError(false);
    }
  };

  const onBlurURIs = (e) => {
    setSubmitClick(false);
    setRedirectUriErrorText('');
    if (e.target.value.length < 1) {
      setRedirectUriError(false);
    }
  };

  const validateCompanyName = (e) => {
    if (e.target.value.length < 1) {
      setFormData({ ...formData, company: '' });
    } else if (e.target.validity.valid) {
      setCmpNameError(false);
      setCmpNameErrortext('');
      setFormData({ ...formData, company: e.target.value });
    } else {
      setCmpNameErrortext(displayCmpNameError(e.target.value));
      setCmpNameError(true);
    }
  };

  const displayCmpNameError = (text) => {
    if (text.length < 1) {
      return 'Please enter a company name';
    } else {
      return 'Please enter a valid company name, without characters ^~`!@#$%^&*()_+={}[]|/:;"<>,.?';
    }
  };

  const validateEmail = (e) => {
    if (e.target.value.length < 1) {
      setFormData({ ...formData, email: '' });
    } else if (e.target.checkValidity()) {
      setEmailError(false);
      setEmailErrortext('');
      setFormData({ ...formData, email: e.target.value });
    } else {
      setEmailErrortext(displayEmailError(e.target.value));
      setEmailError(true);
    }
  };

  const displayEmailError = (text) => {
    if (text.length < 1) {
      return 'Please enter an email address';
    } else {
      return 'Please enter a valid email address';
    }
  };

  const validateAppName = (e) => {
    if (e.target.value.length < 1) {
      setFormData({ ...formData, appName: '' });
    } else if (e.target.validity.valid) {
      setAppNameError(false);
      setAppNameErrortext('');
      setFormData({ ...formData, appName: e.target.value });
    } else {
      setAppNameError(true);
      setAppNameErrortext(displayAppNameError(e.target.value));
    }
  };

  const displayAppNameError = (text) => {
    if (text.length < 1) {
      return 'Please enter a app name';
    } else {
      return 'Please enter a valid app name, without characters ^~`!@#$%^&*()_+={}[]|/:;"<>,.?';
    }
  };

  const validateURIs = (e) => {
    if (e.target.value.length < 1) {
      setFormData({ ...formData, urls: '' });
    } else if (e.target.value.length > 0) {
      setRedirectUriError(false);
      setRedirectUriErrorText('');
      setCounterURI(e.target.value.length);
      setFormData({ ...formData, urls: e.target.value });
    } else {
      setRedirectUriError(true);
      setRedirectUriErrorText('Please fill out this field.');
    }
  };

  const changeGrantType = (e) => {
    if (e.target.value.length < 1) {
      setFormData({ ...formData, grantType: '' });
    } else if (e.target.value.length > 0) {
      setGrantTypeError(false);
      setGrantTypeErrorText('');
      setFormData({ ...formData, grantType: e.target.value });
    } else {
      setGrantTypeError(true);
      setGrantTypeErrorText('Please select an item in the list');
    }
  };
  //RECAPTCHA
  useEffect(() => {
    // Load the reCAPTCHA script
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      // Cleanup the script on component unmount
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const submitRequest = async () => {
      setLoading(true);
      const response = await postThirdPartyRequest(
        formData.fullName,
        formData.email,
        formData.appName,
        formData.company,
        formData.grantType,
        formData.urls,
      );

      if (response?.data?.status === 200) {
        if (response?.data?.response === 'Form submitted successfully') {
          setShowSuccessError(true);
          setSuccessMessage(response?.data?.response);
        } else {
          setShowSuccessError(true);
          setErrorMessage(response?.data?.errorMessage);
        }
      } else {
        setShowSuccessError(true);
        if (response?.data?.errorType === 'KeyError') {
          setErrorMessage('Incorrect Input Received, Please correct and try again');
        } else if (response?.data?.errorMessage !== undefined) {
          setErrorMessage(response?.data?.errorMessage);
        } else {
          setErrorMessage(response?.message);
        }
      }
      setLoading(false);
    };
    const reCaptchaVerify = async () => {
      //RECAPTCHA START-----
      if (window.grecaptcha && window.grecaptcha.enterprise) {
        window.grecaptcha.enterprise.ready(async () => {
          try {
            const token = await window.grecaptcha.enterprise.execute(
              process.env.REACT_APP_RECAPTCHA_SITE_KEY,
              { action: 'SUBMIT' },
            );
            const score = await sendTokenToRecaptcha(token);

            if (score < 0.5) {
              setShowRecaptchaMessage(true);
              window.scrollTo(0, 0);
            } else if (score >= 0.5) {
              setShowRecaptchaMessage(false);
              submitRequest();
            } else {
              setShowRecaptchaMessage(true);
              window.scrollTo(0, 0);
            }
          } catch (err) {
            setShowRecaptchaMessage(true);
            window.scrollTo(0, 0);
          }
        });
      }
      const sendTokenToRecaptcha = async (token) => {
        const response = await fetch(`${process.env.REACT_APP_RECAPTCHA_API_KEY}`, {
          method: 'POST',
          body: JSON.stringify({
            event: {
              token: token,
              expectedAction: 'SUBMIT',
              siteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
            },
          }),
        });
        const data = await response.json();
        if (data.tokenProperties.action === 'SUBMIT' && data.tokenProperties.valid) {
          const score = data.riskAnalysis.score;
          return score;
        }
        return null;
      };
      //RECAPTCHA END-----
    };

    if (submitClick) {
      setSubmitClick(false);
      if (
        formData.fullName.length < 1 &&
        formData.company.length < 1 &&
        formData.email.length < 1 &&
        formData.appName.length < 1 &&
        formData.grantType.length < 1 &&
        formData.urls.length < 1
      ) {
        setNameError(true);
        setNameErrortext('please enter a full name');
        setCmpNameError(true);
        setEmailError(true);
        setAppNameError(true);
        setRedirectUriError(true);
        setGrantTypeError(true);
        window.scrollTo(0, 0);
      }
      if (formData.fullName.length < 1) {
        setNameError(true);
        setNameErrortext('please enter a full name');
        window.scrollTo(0, 0);
      } else if (formData.company.length < 1) {
        setCmpNameError(true);
        setCmpNameErrortext('please enter a company name');
        window.scrollTo(0, 0);
      } else if (formData.email.length < 1) {
        setEmailError(true);
        setEmailErrortext('please enter an email address');
        window.scrollTo(0, 0);
      } else if (formData.appName.length < 1) {
        setAppNameError(true);
        setAppNameErrortext('Please enter an app name');
        window.scrollTo(0, 0);
      } else if (formData.grantType.length < 1) {
        setGrantTypeError(true);
        setGrantTypeErrorText('Please select an item in the list');
        window.scrollTo(0, 0);
      } else if (formData.urls.length < 1) {
        setRedirectUriError(true);
        setRedirectUriErrorText('Please fill out this field');
      } else if (!formData.agree) {
        setSelectCheckBoxError(true);
      } else {
        window.scrollTo(0, 0);
        reCaptchaVerify();
      }
    }
  }, [submitClick, formData]);
  /***************** Submit Button Click ******************/
  const handleSubmit = () => {
    setShowRecaptchaMessage(false);
    setSubmitClick(true);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          p: 2,
          borderRadius: 2,
          bgcolor: '#FFF',
          minWidth: '50%',
          padding: '20px 0 65px 0',
          minHeight: '100vh',

          '@media (max-width:992px)': {
            minWidth: '70%',
            padding: '20px 0 65px 0',
          },
          opacity: '2',
        }}
      >
        <Grid
          container
          spacing={0}
        >
          <Grid
            item
            xs={2}
            lg={1}
            xl={2}
          />
          <Grid
            item
            xs={7}
            lg={6}
            md={7}
            xl={5}
            sx={{ paddingBottom: '5%' }}
          >
            <FormContainer
              key={2}
              elevation={2}
              sx={{ paddingBottom: '0px' }}
            >
              {showRecaptchaMessage && (
                <Box
                  display="flex"
                  alignItems="center"
                  sx={{
                    padding: '16px',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    lineHeight: '10px',
                  }}
                >
                  <WarningIcon sx={{ fontSize: '0.8rem', paddingRight: '5px', color: '#c10000' }} />
                  <RecaptchaMessage>
                    Failed ReCaptcha Validation. Please try again later or contact support.
                  </RecaptchaMessage>
                </Box>
              )}
              <SubHeading>Third Party Sandbox Request Form</SubHeading>

              {showSuccessError ? (
                <>
                  <Button onClick={backtoRequestForm} sx={{display:'flex',alignItems:'center',padding:0}}><ArrowBackIosIcon sx={{fontSize:'0.8rem',margin:0}}/><span style={{margin:0,padding:0}}>Back</span></Button>
                  <Alert severity={successMessage.length > 1 ? 'success' : 'warning'}>
                    <SuccessMessage>
                      {successMessage.length > 1 ? successMessage : errorMessage}
                    </SuccessMessage>
                  </Alert>
                </>
              ) : (
                <form className="form">
                  {loading && <Spinner />}
                  {/* Full Name */}
                  <CustomTooltip
                    title={nameErrorText}
                    arrow
                    open={nameError ? true : false}
                  >
                    <TextField
                      fullWidth={true}
                      label="Full name"
                      required
                      autoComplete="off"
                      onChange={(e) => {
                        validateFullName(e);
                      }}
                      onBlur={(e) => {
                        onBlurNameField(e);
                      }}
                      sx={{ padding: '0 0 16px', mt: '5' }}
                      size="small"
                      inputProps={{
                        maxLength: 120,
                        pattern: '[A-Za-z0-9 ]+',
                        border: '#dee2e6',
                      }}
                      error={nameError}
                      disabled={loading}
                    />
                  </CustomTooltip>

                  {/* Company Name */}
                  <CustomTooltip
                    title={cmpNameErrorText}
                    arrow
                    open={cmpNameError ? true : false}
                    placement="bottom"
                  >
                    <TextField
                      label="Company name"
                      fullWidth={true}
                      required
                      name="company_name"
                      sx={{ padding: '0 0 16px' }}
                      size="small"
                      onChange={(e) => validateCompanyName(e)}
                      inputProps={{
                        maxLength: 90,
                        pattern: '[A-Za-z0-9 ]+',
                        border: '#dee2e6',
                      }}
                      onBlur={(e) => {
                        onBlurCmpNameField(e);
                      }}
                      error={cmpNameError}
                      disabled={loading}
                    />
                  </CustomTooltip>

                  {/* Email */}
                  <CustomTooltip
                    title={emailErrorText}
                    arrow
                    open={emailError ? true : false}
                    placement="bottom"
                  >
                    <TextField
                      label="Email"
                      fullWidth={true}
                      name="email"
                      required
                      onChange={(e) => {
                        validateEmail(e);
                      }}
                      onBlur={(e) => {
                        onBlurEmailField(e);
                      }}
                      sx={{ padding: '0 0 10px' }}
                      size="small"
                      inputProps={{ maxLength: 120, type: 'email' }}
                      error={emailError}
                      disabled={loading}
                    />
                  </CustomTooltip>

                  {/* App Name - appNameErrorText*/}
                  <CustomTooltip
                    title={appNameErrorText}
                    arrow
                    open={appNameError ? true : false}
                    placement="bottom"
                  >
                    <TextField
                      label="App name"
                      margin="dense"
                      name="app_name"
                      fullWidth={true}
                      required
                      onChange={(e) => validateAppName(e)}
                      onBlur={(e) => {
                        onBlurAppNameField(e);
                      }}
                      sx={{ padding: '0 0 16px' }}
                      size="small"
                      inputProps={{ maxLength: 90, pattern: '[A-Za-z0-9 ]+', border: '#dee2e6' }}
                      error={appNameError}
                      disabled={loading}
                    />
                  </CustomTooltip>

                  {/* Authorization Grant Type */}
                  <FormControl
                    fullWidth
                    sx={{ padding: '0 0 20px' }}
                    size="small"
                  >
                    <InputLabel id="gtypeLabel"> Authorization Grant Type&nbsp;&#42;</InputLabel>
                    <CustomTooltip
                      title={granttypeErrorText}
                      arrow
                      open={granttypeError ? true : false}
                      placement="bottom"
                    >
                      <Select
                        labelId="gtypeLabel"
                        label="Authorization Grant Type"
                        placeholder="Please select an Option"
                        title="Please select an item in the list"
                        required
                        fullWidth={true}
                        value={formData.grantType}
                        onChange={(e) => changeGrantType(e)}
                        error={granttypeError}
                        disabled={loading}
                      >
                        <MenuItem value={'Authorization code'}>Authorization code</MenuItem>
                        <MenuItem value={'Authorization code + PKCE'}>
                          Authorization code + PKCE
                        </MenuItem>
                      </Select>
                    </CustomTooltip>
                  </FormControl>
                  {/* List of Redirect URLs */}
                  {/* <CounterLabel>List of Redirects URIs&nbsp;&#42;</CounterLabel> */}
                  <CustomTooltip
                    title={redirectUriErrorText}
                    arrow
                    open={redirectUriError ? true : false}
                    placement="bottom"
                  >
                    <CounterWrap>
                      <TextField
                        label="List of Redirect URIs&nbsp;"
                        name="redirectURIs"
                        fullWidth={true}
                        required
                        onBlur={(e) => {
                          onBlurURIs(e);
                        }}
                        onChange={(e) => validateURIs(e)}
                        sx={{ padding: '0 0 16px' }}
                        size="small"
                        rows={4}
                        multiline
                        inputProps={{ maxLength: 150 }}
                        error={redirectUriError}
                        disabled={loading}
                      />

                      {formData.urls?.length > 0 ? (
                        <Counter> {`${counterURI} / 150`} </Counter>
                      ) : (
                        <Counter> 0 / 150 </Counter>
                      )}
                    </CounterWrap>
                  </CustomTooltip>
                  {/* Agreement checkbox */}
                  <FormControlLabel
                    control={
                      <>
                        <CustomTooltip
                          title="Please check this box if you want to proceed"
                          arrow
                          open={selectCheckBoxError ? true : false}
                          placement="bottom"
                        >
                          <Checkbox
                            checked={formData.agree}
                            onChange={(e) => {
                              handleCheckboxchange(e);
                            }}
                            name="agree"
                            sx={{
                              color: '#dee2e6',
                              '&.Mui-checked': {
                                color: 'primary',
                              },
                              // '&.Mui-'
                              '& .MuiSvgIcon-root': { fontSize: 28 },
                            }}
                            error={submitClick && !formData.agree ? true : false}
                            title="Please check this box if you want to proceed"
                            disabled={loading}
                          />
                        </CustomTooltip>
                        <TermsLabel>
                          I agree to the Healthfirst{' '}
                          <a href="https://healthfirst.org/terms-of-use">Terms of Service</a> and{' '}
                          <a href="https://assets.healthfirst.org/api/pdf?id=pdf_267ff1120f&amp;key=2a057fc3de988ef49277dcc39931e7444611493e+rel%3D&amp;v=0330142822">
                            Privacy Policy
                          </a>
                        </TermsLabel>
                      </>
                    }
                  />
                  <p>
                    <Small>
                      <em>
                        You must agree to the Healthfirst Terms of Service and Privacy Policy to use
                        the Healthfirst Developer Application
                      </em>
                    </Small>
                  </p>
                  {/* Submit Button */}
                  <Button
                    variant="contained"
                    sx={{
                      width: '127px',
                      height: '46px',
                      fontSize: '1.2rem',
                      fontWeight: '300',
                      fontFamily: ' MuseoSans',
                    }}
                    disabled={loading}
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </form>
              )}
            </FormContainer>
          </Grid>
        </Grid>
      </Box>
      <Footer className="sticky bottom-0" />
    </ThemeProvider>
  );
};

export default RequestForm;
